import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import AgeBySingleYearOfAge from './age-by-single-year-of-age';
import AgeBySingleYearOfAgeDetail from './age-by-single-year-of-age-detail';
import AgeBySingleYearOfAgeUpdate from './age-by-single-year-of-age-update';
import AgeBySingleYearOfAgeDeleteDialog from './age-by-single-year-of-age-delete-dialog';

const AgeBySingleYearOfAgeRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<AgeBySingleYearOfAge />} />
    <Route path="new" element={<AgeBySingleYearOfAgeUpdate />} />
    <Route path=":id">
      <Route index element={<AgeBySingleYearOfAgeDetail />} />
      <Route path="edit" element={<AgeBySingleYearOfAgeUpdate />} />
      <Route path="delete" element={<AgeBySingleYearOfAgeDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default AgeBySingleYearOfAgeRoutes;
